import { formatMinorUnits as formatWithCurrency } from '@seek/currency';
import { Text } from 'braid-design-system';
import React, { type ComponentProps } from 'react';

import { useConfig } from 'src/app/shared/hooks/useConfig';
import type { Currency } from 'src/graphql/generated';

interface CurrencyTextProps extends ComponentProps<typeof Text> {
  value: number;
  currency: Currency;
}

export const PriceWithCurrencyText = ({
  value,
  currency,
  ...textProps
}: CurrencyTextProps) => {
  const { getLocale } = useConfig();
  const price = formatWithCurrency(value, {
    currency,
    locale: getLocale(),
  });

  return <Text {...textProps}>{price}</Text>;
};
